import { render, staticRenderFns } from "./OneToOne.vue?vue&type=template&id=647dcdd8&scoped=true&"
import script from "./OneToOne.vue?vue&type=script&lang=ts&"
export * from "./OneToOne.vue?vue&type=script&lang=ts&"
import style0 from "./OneToOne.vue?vue&type=style&index=0&id=647dcdd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647dcdd8",
  null
  
)

export default component.exports